if (!customElements.get('arw-mobile-buy')) {
  customElements.define('arw-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.info = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.info) return;
      this.addButton = this.querySelector('[data-mobile-add]');
      this.optionButton = this.querySelector('[data-change-size]');
      this.selection = this.querySelector('[data-mobile-selection]');
      this.chooseLabel = this.selection.textContent;
      this.price = this.querySelector('[data-mobile-price]');
      this.label = this.querySelector('[data-mobile-label]');
      this.sheet = this.querySelector('dialog');
      this.media = matchMedia('(max-width: 749px)');
      this.chosen = this.dataset.default === 'true' || new URL(location.href).searchParams.has('variant');
      this.sync = this.sync.bind(this);
      this.onChange = e => {
        if (e.target.closest('variant-selects')) { this.chosen = true; this.sync(); }
      };
      this.info.addEventListener('change', this.onChange);
      this.optionButton.addEventListener('click', () => this.openSizes());
      this.querySelector('[data-mobile-close]').addEventListener('click', () => this.sheet.close());
      this.querySelector('[data-mobile-done]').addEventListener('click', () => { this.chosen = true; this.sheet.close(); });
      this.sheet.addEventListener('close', () => {
        const picker = this.sheet.querySelector('variant-selects');
        if (this.marker?.isConnected && picker) this.marker.replaceWith(picker);
        this.sync(); this.optionButton.focus({preventScroll:true});
      });
      this.sheet.addEventListener('click', e => { if (e.target === this.sheet) { const r=this.sheet.getBoundingClientRect(); if(e.clientY<r.top) this.sheet.close(); } });
      this.addButton.addEventListener('click', () => {
        if (!this.chosen) { this.openSizes(); return; }
        const original = this.original();
        if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
      });
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target) || r.target.closest?.('variant-selects'))) this.sync();
      });
      this.observer.observe(this.info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value']});
      this.rootObserver = new MutationObserver(this.sync);
      this.rootObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      window.addEventListener('scroll',this.sync,{passive:true});
      this.media.addEventListener('change',this.sync);
      this.sync();
    }
    original() { return document.getElementById(`ProductSubmitButton-${this.dataset.section}`); }
    openSizes() {
      this.picker = this.info.querySelector('variant-selects');
      if (!this.picker) return;
      this.marker = document.createElement('span');
      this.picker.before(this.marker);
      this.querySelector('[data-mobile-picker]').append(this.picker);
      this.sheet.showModal();
      this.sync();
    }
    setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    sync() {
      const original = this.original();
      if (!original) { this.hidden=true; return; }
      const rect=original.getBoundingClientRect();
      this.hidden = !this.media.matches || (!this.sheet.open && rect.top < innerHeight && rect.bottom > 0);
      if (!this.media.matches && this.sheet.open) this.sheet.close();
      this.addButton.disabled = this.chosen && (original.disabled || original.getAttribute('aria-disabled') === 'true');
      this.setText(this.label, original.querySelector('span')?.textContent.trim() || original.textContent.trim());
      this.optionButton.hidden = this.dataset.default === 'true';
      const selections=[...this.info.querySelectorAll('variant-selects input:checked, variant-selects select')].filter(e=>!e.closest('.arw-single-color')).map(e=>e.tagName==='SELECT'?e.selectedOptions[0]?.textContent.trim():e.value).filter(Boolean);
      this.setText(this.selection,this.chosen ? [...new Set(selections)].join(' / ') : this.chooseLabel);
      const price=this.info.querySelector('[id^="price-"] .price');
      const campaign=price?.querySelector('.arw-opening-price');
      const activeCampaign=campaign && getComputedStyle(campaign).display!=='none';
      const sale=price?.classList.contains('price--on-sale');
      const amount=activeCampaign ? campaign.querySelector('strong') : price?.querySelector(sale?'.price-item--sale':'.price__regular .price-item--regular');
      const old=activeCampaign ? campaign.querySelector('s') : sale ? price?.querySelector('.price__sale s') : null;
      const next=[amount?.textContent.trim()||'',old?.textContent.trim()||''];
      if(this.price.dataset.value!==next.join('|')) {
        this.price.dataset.value=next.join('|'); this.price.replaceChildren();
        if(next[1]) {const s=document.createElement('s');s.textContent=next[1];this.price.append(s);}
        const strong=document.createElement('strong');strong.textContent=next[0];this.price.append(strong);
      }
      this.querySelector('[data-mobile-done]').disabled=original.disabled || original.getAttribute('aria-disabled')==='true';
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.rootObserver?.disconnect();
      this.info?.removeEventListener('change',this.onChange);
      window.removeEventListener('scroll',this.sync); this.media?.removeEventListener('change',this.sync);
    }
  });
}
